var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 14.0625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18.24 0.00 L 1.76 0.00 C 0.79 0.00 0.00 0.79 0.00 1.76 L 0.00 12.30 C 0.00 13.28 0.79 14.06 1.76 14.06 L 18.24 14.06 C 19.21 14.06 20.00 13.28 20.00 12.30 L 20.00 1.76 C 20.00 0.79 19.22 0.00 18.24 0.00 M 18.00 1.17 C 17.64 1.53 11.46 7.68 11.24 7.89 C 10.91 8.22 10.47 8.40 10.00 8.40 C 9.53 8.40 9.09 8.22 8.76 7.89 C 8.61 7.75 2.50 1.67 2.00 1.17 L 18.00 1.17 M 1.17 12.07 L 1.17 2.00 L 6.24 7.03 L 1.17 12.07 M 2.00 12.89 L 7.07 7.86 L 7.93 8.72 C 8.48 9.27 9.22 9.58 10.00 9.58 C 10.78 9.58 11.52 9.27 12.07 8.72 L 12.93 7.86 L 18.00 12.89 L 2.00 12.89 M 18.83 12.07 L 13.76 7.03 L 18.83 2.00 L 18.83 12.07",
    fill: "#4B1498",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ac5dde062e61abc8096a6e239af15541.svg";
export { ForwardRef as ReactComponent };